<template>
	<div class="nav">
		<div class="container">
			<div class="login" @click="toHome()">
				<img style="width: 117px;" src="../../../assets/img/logo.png" alt="">
			</div>
			<div class="logo">
				<!-- 				<!-- :class="['nav-item', { 'active': $route.path === item.path }]" --> 
			<div class="nav-items">
			  <div 
				v-for="(item, i) in navList" 
				:key="i" 
				@click="toDetail(item, i)" 
				:class="['nav-item', { 'active':i === 10 }]"
			  >
				{{ item.name }}
			  </div>
			</div>
			<div class="logingo" @click="gourl('http://42.194.202.49/star-game/login')">
				登录
			</div>
			<div class="tiy" @click="gourl('http://42.194.202.49/star-game/login')">
				免费体验
			</div>
			</div>
		</div>
	</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
    name: 'Nav',
    data() {
        return {
            navList: [
                {
                    name: '平台优势',
                    path: 'a',
                },
                {
                    name: '智能体验',
                    path: 'b',
                },
				{
				    name: '服务企业',
				    path: 'c',
				},
				{
				    name: '联系我们',
				    path: 'd',
				},
            ],
            register: {},
            isLogin: null,
            mobile: '18888888888',
            logoImage: null // 新增 logoImage 数据属性
        };
    },
    computed: {
        ...mapGetters(["avatar", "name", "roles", "isPay"]),
    },
    mounted() {
        this.isLogin = localStorage.getItem("token") ? true : false;
        const cachedFooterData = localStorage.getItem('footerData');
        if (cachedFooterData) {
            const footerData = JSON.parse(cachedFooterData);
            this.$nextTick(() => {
                this.logoImage = footerData.beianImage; // 从缓存中读取 beianImage
            });
        }
    },

    methods: {
        logout() {
            this.$message.success('退出成功')
            localStorage.removeItem('token')
            this.isLogin = false
            this.$router.replace({
                path: '/login'
            })
        },
        login(e) {
            if (e == 'add') {
                this.$router.push('/register')
            } else {
                this.$router.push('/login')
            }
        },
        info() {
            this.$router.push({
                path: '/info'
            })
        },
        toDetail(item, i) {
            // this.$router.push({
            //     path: item.path
            // })
			document.getElementById(item.path).scrollIntoView({
			  behavior: 'smooth' // 平滑滚动效果
			});
        },
		toHome() {
			//跳转首页
		   this.$router.push({
		       path: '/home'
		   })
		},
		gourl(url) {
		// 新开一个窗口，跳转第三方地址
		window.open(url, '_blank');
		},
    },
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  top: 0;
  height: 74px;
  z-index: 100;
  background: rgba(255,255,255,0.85);
  width: 100vw;
  margin: 0 auto;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .container {
    width: 1211px; // 增加容器宽度
    margin: 0 auto;
    display: flex;
    justify-content: space-between; // 使用 space-between 来分配空间
    align-items: center; // 垂直居中对齐

    .logo {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex: 1; // 让 logo 部分占据剩余空间

      .nav-items {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        
        &::-webkit-scrollbar {
          display: none; /* WebKit */
        }
    }
  }

  .nav-item {
        flex: 0 0 auto;
        padding: 0 21px;
        height: 72px;
        line-height: 72px;
        text-align: center;
        cursor: pointer;
        white-space: nowrap;
        transition: color 0.3s;
		font-size: 16px;
		color: #51619F;
        &:hover, &.active {
          color: #7754EA;
		  font-weight: 700;
        }
      }
	.logingo{
		width: 81px;
		height: 46px;
		border-radius: 10px 10px 10px 10px;
		border: 1px solid #9A9CE8;
		margin-left: 50px;
		font-family: Inter, Inter;
		font-weight: 600;
		font-size: 15px;
		color: #6166CE;
		line-height: 46px;
		text-align: center;
		cursor: pointer;
	}
	.tiy{
		width: 110px;
		height: 44px;
		background: linear-gradient( 135deg, #6366F1 0%, #8B5CF6 100%);
		box-shadow: 0px 4px 14px 0px rgba(99,102,241,0.35);
		border-radius: 10px 10px 10px 10px;
		font-family: Inter, Inter;
		font-weight: 600;
		font-size: 15px;
		color: #FFFFFF;
		line-height: 44px;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-left: 16px;
		cursor: pointer;
	}
    .login {
      display: flex;
      align-items: center;
		cursor: pointer;

      .loginOut {
        line-height: 72px;

        .user-avatar {
          cursor: pointer;
          width: 20px;
          height: 20px;
          border-radius: 10px;
          margin: -5px 0 0 5px;
        }

        .avatar-wrapper {
          display: flex;
          align-items: center;
          height: 72px;
        }
      }

      .btn {
        display: flex;

        div {
          width: 50px;
          height: 72px;
          line-height: 72px;
          text-align: center;
          cursor: pointer;
        }
      }
    }
  }

  .active {
    color: #7754EA;
  }

  
  @media (max-width: 768px) {
  .container {
    width: 95%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: red;
  }

  .logo {
    width: 100%;
  }

  .login {
    width: 100%;
    margin-bottom: 10px;
  }
}
}
</style>